import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { LegalOnboardingDetail } from "../schema/handler-functions";

interface Props {
  detail: LegalOnboardingDetail | null;
}

const toRespuesta = (value: unknown): string => {
  if (typeof value === "boolean") return value ? "Sí" : "No";
  return "-";
};

export const OtrasDdjjCard = ({ detail }: Props) => {
  const rows = [
    {
      label: "Declaración Jurada FATCA",
      respuesta: toRespuesta(detail?.esFatca),
    },
    {
      label: "Declaración Jurada OCDE",
      respuesta: toRespuesta(detail?.esOcde),
    },
  ];

  return (
    <Flex
      flexDir="column"
      border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      borderRadius="12px"
      paddingBottom="12px"
    >
      <Grid templateColumns="repeat(2, 1fr)" width="100%">
        <GridItem paddingX="24px" paddingY="14px">
          <Text
            fontWeight={700}
            fontSize={{ base: "11px", md: "12px", lg: "12px" }}
            color={AppColors.GRAY_TEXT}
          >
            OTRAS DDJJ
          </Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="14px">
          <Text
            fontWeight={700}
            fontSize={{ base: "11px", md: "12px", lg: "12px" }}
            color={AppColors.GRAY_TEXT}
          >
            RESPUESTA
          </Text>
        </GridItem>

        {rows.map((row, index) => {
          const backgroundColor =
            index % 2 === 0 ? AppColors.BACKGROUND_SECONDARY : undefined;

          return (
            <Flex as="span" key={row.label} display="contents">
              <GridItem
                paddingX="24px"
                paddingY="14px"
                backgroundColor={backgroundColor}
              >
                <Text className="account-value-label">{row.label}</Text>
              </GridItem>
              <GridItem
                paddingX="24px"
                paddingY="14px"
                backgroundColor={backgroundColor}
              >
                <Text className="account-value-label">{row.respuesta}</Text>
              </GridItem>
            </Flex>
          );
        })}
      </Grid>
    </Flex>
  );
};
